import React, { useContext } from 'react'
import { BsCartPlus } from 'react-icons/bs';
import { VscTrash } from 'react-icons/vsc';
import { AiOutlineShopping } from 'react-icons/ai';
import { FaStar } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { WishListContext } from '../../Context/WishListContext.jsx';
import emptyWish from "./../../assets/wishlist.gif";
import { CartContext } from '../../Context/CartContext.jsx';
import { Helmet, HelmetProvider } from 'react-helmet-async';

const WishList = () => {
    const { wishItems, removeProductFromWishList } = useContext(WishListContext)
    const { addProductToCart, removeProductFromCart, cartContains, cartIds } = useContext(CartContext)

    return (
        <HelmetProvider>
            <Helmet>
                <title>FreshCart | WishList</title>
            </Helmet>
            {wishItems?.length ?
                <div className="container">
                    <div className="flex flex-col gap-y-5 justify-center items-center md:w-3/4 m-auto px-5 md:px-0">
                        <h2 className="text-3xl py-2 font-medium">My WishList</h2>
                        {wishItems.map((item, i) => (
                            <div key={i} className="item flex-col sm:flex-row flex border shadow w-full">
                                <div className="img-box sm:w-1/5 p-3">
                                    <Link to={`/products/${item._id}`}>
                                        <img className="m-auto w-full" src={item.mainImage.path} alt="Product_Image" /></Link>
                                </div>
                                <div className="body details p-2 py-5 sm:w-3/5">
                                    {/* <p className="text-gray-500 my-1">{`${item.brandId?.name?.charAt(0).toUpperCase() + item.brandId?.name?.slice(1)}`}</p> */}
                                    <h2 className="text-xl font-medium">{`${item.name?.charAt(0).toUpperCase() + item.name?.slice(1)}`}</h2>
                                    <div className="flex gap-2 my-2">
                                        <div className='flex items-center gap-1.5 bg-gray-50 shadow-sm rounded py-1 px-3 w-max'>
                                            <FaStar className=" text-yellow-400" />
                                            <span>{item.AvgRate}</span>
                                        </div>
                                        <div className='flex items-center bg-gray-50 shadow-sm rounded py-1 px-3 w-max'>
                                            <span>{item.ratingCount} <span className="text-sm mx-1">Ratings</span></span>
                                        </div>
                                    </div>
                                    <p className="text-gray-600 font-medium my-1">Price : <span className="text-black">{item.priceAfterDiscount.toFixed(2)} EGP</span></p>
                                    <p className="text-gray-600 font-medium my-1">Quantity : <span className="text-black">{item.stock} Items</span></p>
                                    <div className='my-1 text-sm flex gap-2'>
                                        <span className='text-gray-600 font-medium'>Colors</span>{item.colors?.map((color, i) => (
                                            <span key={i} className={` flex items-center bg-gray-50 shadow-sm rounded py-1 px-3 w-max`}>{color}</span>
                                        ))}
                                    </div>
                                </div>
                                <div className="btns sm:w-1/5 flex flex-col gap-y-2 justify-center items-center p-2">
                                    {!cartContains(cartIds, item._id) ? <button onClick={() => addProductToCart(item._id, 1)} className='flex items-center justify-center gap-1 py-2 w-full border border-green-600 text-green-600 hover:bg-green-600 hover:text-white rounded group'>
                                        <BsCartPlus className='group-hover:animate-bounce' />
                                        <span className='text-xs font-medium'> ADD TO CART</span>
                                    </button> : <button onClick={() => removeProductFromCart(item._id)} className='flex items-center justify-center gap-1 py-2 w-full border border-red-600 text-red-600 hover:bg-red-600 hover:text-white rounded group'>
                                        <BsCartPlus className='group-hover:animate-bounce' />
                                        <span className='text-xs font-medium'> REMOVE FROM CART</span>
                                    </button>}
                                    <button className='flex items-center justify-center gap-2 py-2 w-full border border-amber-600 text-amber-600 hover:bg-amber-600 hover:text-white rounded group'>
                                        <AiOutlineShopping size={16} className='group-hover:animate-bounce' />
                                        <span className='text-xs font-medium'> BUY NOW</span>
                                    </button>
                                    <button onClick={() => removeProductFromWishList(item._id)} className='flex items-center justify-center gap-2 py-2 w-full border border-red-600 text-red-600 hover:bg-red-600 hover:text-white rounded group'>
                                        <VscTrash className='group-hover:animate-bounce' />
                                        <span className='text-xs font-medium'> REMOVE</span>
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div> : <div className='container min-h-96 '>
                    <div className="flex flex-wrap gap-4 h-full flex-col justify-center items-center p-3 text-center">
                        <div className="img-box">
                            <img src={emptyWish} alt="" />
                        </div>
                        {/* <p className="text-2xl font-medium">Your WishList is Empty</p> */}
                        {/* <p className="text-slate-500 text-base">Explore More and ShortList some items</p> */}
                        <Link to="/" className='bg-red-500 text-slate-50 rounded py-2 px-6 font-bold text-sm uppercase hover:bg-red-700'>Start Shopping</Link>
                    </div>
                </div>}
        </HelmetProvider>
    )
}

export default WishList